// extracted by mini-css-extract-plugin
module.exports = {"edits_fonts":"Container_edits_fonts__1H537","shadow":"Container_shadow__3jhpo"};